var api = require('api')
var local = require('common/store/local')

var getAuthToken = function (creds, next, err) {
  var clientOptions = local.get('client.options')
  var options = {
    emulateJSON: true,
    credentials: false,
    headers: {
      'Authorization': clientOptions.auth
    }
  }
  var formData = new FormData()
  formData.append('username', creds.username)
  formData.append('password', creds.password)
  formData.append('recaptchaData', creds.recaptchaData)
  formData.append('grant_type', 'password')
  formData.append('scope', clientOptions.scope)

  creds.grant_type = 'password'
  creds.scope = 'default'
  // api.Auth.save(formData, options).then(next, err)
  api.$http.post(api.$host + '/oauth/token', formData, options).then(next, err)
}

var login = function (credentials, next, err) {
  getAuthToken(credentials, function (response) {
    var authData = response.data
    // console.log(authData)
    authData.username = credentials.username
    return next(authData)
  }, err)
}

var register = function (user, next, err) {
  user.langCode = local.get('client.language') || 'en'
  api.User.save(user).then(function (response) {
    // next(response.data.id)
    next(response.data)
    // if (user.Credentials) {
    //   login(user.Credentials, function (authData) {
    //   }, err)
    // } else {
    //   next(response.data.id)
    // }
  }, err)
}

var validate = function (user, next, err) {
  user.langCode = local.get('client.language') || 'en'
  api.User.validate(user).then(function (response) {
    next(response.data)
  }, err)
}

var verify = function (token, next, err) {
  console.log('token: ' + token)
  api.User.verifyAccount({token: token}).then(function (response) {
    next(response.data)
    // next(response.data.context)
  }, err)
}

module.exports = {
  login: login,
  register: register,
  verify: verify,
  validate: validate
}



// WEBPACK FOOTER //
// ./src/api/Auth.js